import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'program-generator',
  templateUrl: './program-generator.component.html'
})

export class ProgramGeneratorComponent {

  @Output() onSave: EventEmitter<any> = new EventEmitter();
  @Output() onGenerate: EventEmitter<any> = new EventEmitter();

  @Input() public assignedProgramName: any;
  @Input() public assignedProgramNumbersForDomain: any;
  @Input() public programNumber: any;
  @Input() public programLocation: any;

  public showGenerateBtn: boolean = true;

  constructor() {

  }

  generate() {
    this.showGenerateBtn = false;
    this.onGenerate.emit();
  }

  save() {
    this.showGenerateBtn = true;
    let programName = {
      programLocation: this.programLocation,
      programNumber: this.programNumber
    }
    this.onSave.emit(programName);
  }

  cancel() {
    this.showGenerateBtn = true;
  }

  isValidNumber() {
    return !(this.assignedProgramNumbersForDomain.filter(number => this.programNumber == number).length > 0);
  }

  isPositiveNumber() {
    return this.programNumber && this.programNumber > 0;
  }
}



// WEBPACK FOOTER //
// /home/runner/work/slipresistant/slipresistant/client/src/app/program-generator/program-generator.component.ts